module.exports = __webpack_public_path__ + "img/8-11.93992c40.png";